import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import Modal from '@material-ui/core/Modal';
import 'react-phone-number-input/style.css';
import { useSelector } from "react-redux";
import { reactGaEvent } from "examsbook-react-sdk/actions/Common";
import { requestOtpForUnverifiedNumber, updateMobileNumber, verifyOtpOfUnverifiedNumber }
    from "examsbook-react-sdk/services/userService";
import useTranslations from "examsbook-react-sdk/custom-hooks/useTranslations";

/**
 * Update user phone number model,
 * @param props
 * @returns {*}
 * @constructor
 */
function UpdateMobileNumberModel(props) {
    const user = useSelector(state => state.user);
    const t = useTranslations();
    const [ mobileNumber, setMobileNumber ] = useState(user.mobileNumber);
    const [ otp, setOtp ] = useState('');
    const [ numberUpdated, setNumberUpdated ] = useState(false);
    const [ errorMessage, setErrorMessage ] = useState('');

    useEffect(() => {
        setMobileNumber(user.mobileNumber);
    }, [ user ]);

    function storeTempNumberAndRequestOtp() {
        if (mobileNumber && isMobileNumberValid) {
            reactGaEvent("Phone number verification", "OTP requested");
            if (user.mobileNumber !== mobileNumber) {
                updateMobileNumber(mobileNumber).then((res) => {
                    if (res.message) {
                        setErrorMessage(res.message);
                    } else {
                        requestOtpForUnverifiedNumber().then((response) => {
                            setNumberUpdated(true);
                        });
                    }
                });
            }
        }
    }

    function isValidOtp() {
        return (!otp || otp.length === 6);
    }

    function isMobileNumberValid() {
        return (!mobileNumber || mobileNumber.length === 10);
    }

    //close model
    function closeModel() {
        setMobileNumber(user.mobileNumber);
        setNumberUpdated(false);
        setOtp('');
        setErrorMessage('');
        props.toggleMobileNumberModel();
    }

    function verifyAndUpdateNumber() {
        if (mobileNumber && isMobileNumberValid && otp && otp.length === 6) {
            verifyOtpOfUnverifiedNumber(otp).then((response) => {
                if (response.status === 200) {
                    user.mobileNumber = mobileNumber;
                    user.isMobileVerified = true;
                    closeModel();
                } else {
                    //show error
                    setErrorMessage(response.message);
                    if (response.message === 'you have reached maximum attempts, please retry with new OTP') {
                        setTimeout(() => {
                            closeModel();
                        }, 500);
                    }
                }
            });
        }
    }

    function isValidSaveButton() {
        return !!(mobileNumber && mobileNumber.length === 10 && mobileNumber !== user.mobileNumber);
    }

    return (
        <Modal className="password-modal exam-modal contact-modal edit-modal"
               aria-labelledby="simple-modal-title"
               aria-describedby="simple-modal-description"
               open={props.isEditMobileNumberModalOpen}
               onClose={props.toggleMobileNumberModel}>
            <DialogContent>
                <div>
                    <div>
                        <div className="text-field-with-countryCode">
                            <div className="country-code">+91</div>
                            <TextField className="text-field"
                                       type="number"
                                       error={!isMobileNumberValid()}
                                       inputProps={{
                                           maxLength: 10,
                                       }}
                                       onInput={(e) => {
                                           e.target.value = Math.max(0, parseInt(e.target.value, 10)).toString().slice(0, 10);
                                       }}
                                       value={mobileNumber}
                                       onChange={(event) => {
                                           setMobileNumber(event.target.value);
                                       }}/>
                        </div>

                        <div className="otp-field">
                            {numberUpdated ? <TextField className="text-field"
                                                        label={t('OTP')}
                                                        type="number"
                                                        error={!isValidOtp()}
                                                        inputProps={{
                                                            maxLength: 6,
                                                        }}
                                                        onInput={(e) => {
                                                            e.target.value = Math.max(0, parseInt(e.target.value, 10)).toString().slice(0, 6);
                                                        }}
                                                        value={otp}
                                                        onChange={(event) => {
                                                            setOtp(event.target.value);
                                                        }}
                                                        margin="normal"/> : ''}
                            <div className="button-submit resend-otp">
                                {
                                    errorMessage ? <a href="javascript:void(0)"
                                                      onClick={requestOtpForUnverifiedNumber}>{t('RESEND_OTP')}</a> : ''
                                }
                            </div>
                        </div>
                        <span>{errorMessage}</span>
                        {!numberUpdated ? <div className="button-submit"><Button
                            onClick={storeTempNumberAndRequestOtp}
                            disabled={!isValidSaveButton()}>{t('Update')}</Button>
                        </div> : ''}
                        {numberUpdated ? <div className="button-submit"><Button
                            onClick={verifyAndUpdateNumber}
                            disabled={!(isValidSaveButton() && otp && otp.length === 6)}>{t('Verify and Update')}</Button>
                        </div> : ''}
                        <div className="edit-data close-data" onClick={closeModel}><i
                            className="fa fa-close"/></div>
                    </div>
                </div>
            </DialogContent>
        </Modal>
    );
}

export default UpdateMobileNumberModel;
